import React from "react";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../../../API/exercise";
import StuAnswerSub from "../../../Question/components/StuAnswerSub";

interface SubjectiveProps {
    index?: number;
    data: TopicsItem;
    stuDoFlg: string;
    viewPaper: string; //主观题在活动结束的时候老师未批也需要显示x号
}

export default function PageSubjectiveDetail({
    data,
    stuDoFlg,
    index,
    viewPaper
}: SubjectiveProps) {
    return (
        <div className={style.root}>
            <div className={style.top}>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（主观题，{data.score}分）</span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
            </div>

            <StuAnswerSub
                stuDoFlg={stuDoFlg}
                data={data}
                viewPaper={viewPaper}
            />
        </div>
    );
}
